// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../../assets/icons/gray-cross.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectedDiamondCard {
  min-width: 85px;
  padding: 10px;
  background-color: rgba(105, 155, 182, 0.2);
  border-radius: 16px;
  position: relative;
  cursor: pointer;
}
@media (max-width: 380px) {
  .selectedDiamondCard {
    width: 300px;
  }
}
.selectedDiamondCard .selectedDiamondImg {
  height: 65px;
  width: 65px;
  background-repeat: no-repeat;
  background-position: center;
  margin: 0 auto;
}
.selectedDiamondCard .deselectItem {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: #699BB6;
}
.selectedDiamondCard .deselectItem .close, .selectedDiamondCard .deselectItem .count {
  height: 18px;
  width: 18px;
  background-size: cover;
  cursor: pointer;
  color: #FFFFFF;
}
.selectedDiamondCard .deselectItem .close {
  height: 18px;
  width: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  margin-top: 1px;
  margin-left: 1px;
}
.selectedDiamondCard .deselectItem .count {
  margin-left: 6px;
  margin-top: 2px;
  font-size: 13px;
}
.selectedDiamondCard .cardHeading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 120px;
}
.selectedDiamondCard .cardHeading h1 {
  margin: 0;
}
.selectedDiamondCard .cardHeading .title {
  margin-top: 5px;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  margin-bottom: 0px;
  color: #FFFFFF;
}`, "",{"version":3,"sources":["webpack://./src/modules/diamonds/diamondsList/diamondScreen/exchange/selectCard/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAGA;EACI,eAAA;EACC,aAAA;EAED,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAFJ;AAGI;EARJ;IASQ,YAAA;EAAN;AACF;AACI;EACI,YAAA;EACA,WAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;AACR;AACI;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBC3BS;AD4BjB;AAAQ;EACI,YAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EAEA,cCnCC;ADoCb;AACQ;EACI,YAAA;EACA,WAAA;EACA,yDAAA;EACA,eAAA;EACA,gBAAA;AACZ;AACQ;EACI,gBAAA;EACA,eAAA;EACA,eAAA;AACZ;AAEI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAAR;AACQ;EACI,SAAA;AACZ;AACQ;EACI,eAAA;EACA,cC7DC;ED8DD,iCEzDH;EF0DG,eAAA;EACA,kBAAA;EACA,cCjEC;ADkEb","sourcesContent":["@import '../../../../../../scss/colors.scss';\n@import '../../../../../../scss/fonts.scss';\n\n.selectedDiamondCard{\n    min-width: 85px;\n     padding: 10px;\n\n    background-color: rgba($color: $color-Secondary, $alpha: 0.2) ;\n    border-radius: 16px;\n    position: relative;\n    cursor: pointer;\n    @media (max-width: 380px){\n        width: 300px;\n    }\n    .selectedDiamondImg{\n        height: 65px;\n        width: 65px;\n        background-repeat: no-repeat;\n        background-position: center;\n        margin: 0 auto\n    }\n    .deselectItem{\n        position: absolute;\n        right: 0;\n        top: 0;\n        width: 20px;\n        height: 20px;\n        border-radius: 10px;\n        background-color: $color-Secondary;\n        .close,.count{\n            height: 18px;\n            width: 18px;\n            background-size: cover;\n            cursor: pointer;\n    \n            color: $color-White;\n        }\n        .close{\n            height: 18px;\n            width: 18px;\n            background-image: url('../../../../../../assets/icons/gray-cross.svg');\n            margin-top: 1px;\n            margin-left: 1px;\n        }\n        .count{\n            margin-left: 6px;\n            margin-top: 2px;\n            font-size: 13px;\n        }\n    }\n    .cardHeading{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width: 120px;\n        h1{\n            margin:  0;\n        }\n        .title {\n            margin-top:5px;\n            color: $color-White;\n            font-family: $Roboto;\n            font-size: 18px;\n            margin-bottom: 0px;\n            color: $color-White;\n        }\n\n\n    }\n}","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
